var indentation_default = {
  "indentZero": "CNcxn",
  "indentOne": "XMZN5",
  "indentTwo": "faFbN",
  "indentThree": "_5BZE-",
  "indentFour": "AaW4i",
  "indentFive": "LmoVi",
  "indentSix": "zis2Z"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
